import React, { Component, Fragment } from 'react';
import { style, theme, isMVP } from 'constants';
import { getUploadedFiles, getFileFromUploadsGroup } from 'selectors';
import { Scene, View, FlatList, Text, Avatar, Link, Confirm, FilePicker, ASButton } from 'core';
import * as actions from 'actions';
import { IcoTrash, IcoPlus, IcoEdit, IcoGallery, IcoStatus, IcoLanguage, IcoBlock } from 'icons';
import { lang } from 'lang';
import { imageProcessor } from 'utils';

class Account extends Component {
  _uploadAvatar = async files => {
    const { user } = this.props.account;
    const file = await imageProcessor.process(files[0]);
    actions.sendFiles({
      g_id: 'user_avatar',
      u_id: user.id,
      files: [file],
      onSuccess: () => actions.sendUserAvatar({ upload: getUploadedFiles({ g_id: 'user_avatar', u_id: user.id })[0] })
    });
  };

  Header = () => {
    let options = [
      {
        icon: IcoEdit,
        text: lang.CHANGE_NAME,
        onPress: () => actions.clickChangeName()
      },
      {
        icon: IcoGallery,
        text: lang.CHANGE_AVATAR,
        onPress: () => FilePicker.show({ asset_type: FilePicker.TYPES.IMAGE }, this._uploadAvatar)
      }
    ];
    !isMVP &&
      (options = options.concat([
        {
          icon: IcoStatus,
          text: lang.UPDATE_STATUS,
          onPress: () => {}
        }
      ]));

    const { user, avatar_status, upload_avatar } = this.props.account;
    return (
      <Scene style={styles.container}>
        <View style={styles.avatar_cont}>
          <Avatar
            data={user}
            size={170}
            is_large
            style={{ alignSelf: 'center' }}
            avatar_status={avatar_status}
            file={getFileFromUploadsGroup(upload_avatar, user.id)}
            onUploadSuccess={() => {
              actions.markUploadFinished({ g_id: 'user_avatar', u_id: user.id });
              actions.fetch.markFinished(avatar_status.type);
            }}
          />
          <Text style={styles.name}>{user.name}</Text>
          {user.status ? <Text style={styles.description}>{user.status}</Text> : null}
        </View>
        <ASButton options={options} style={{ position: 'absolute', top: 0, right: 0 }} />
        <View style={styles.section_devider} />
        {isMVP ? null : (
          <Fragment>
            <Link onPress={() => {}} style={styles.item_list}>
              <IcoLanguage size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
              <Text style={styles.item_text}>Language</Text>
            </Link>
            <Link onPress={() => {}} style={styles.item_list}>
              <IcoBlock size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
              <Text style={styles.item_text}>{lang.BLOCKED_MEMBERS}</Text>
            </Link>
            <View style={styles.section_devider} />
          </Fragment>
        )}
        <Link style={styles.item_list} onPress={() => actions.clickAddAccount()}>
          <IcoPlus size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
          <Text style={styles.item_text}>{lang.NEW_ACCOUNT}</Text>
        </Link>
      </Scene>
    );
  };

  render() {
    const { user } = this.props.account;
    return (
      <FlatList
        ListHeaderComponent={<this.Header />}
        keyExtractor={item => item}
        data={user.accounts}
        renderItem={({ item }) => (
          <View style={styles.item_list} key={item}>
            <Text style={{ flex: 1, color: theme.gray_color_lighten(0.7), marginLeft: 5 }}>{isNaN(item) ? item : `+${item}`}</Text>
            {user.accounts.length > 1 ? (
              <Link icon={IcoTrash} size={20} color={theme.gray_color} onPress={() => Confirm(lang.ACCOUNT_REMOVE_MSG, () => actions.sendUserRemoveAccount({ account: item }))} />
            ) : null}
          </View>
        )}
      />
    );
  }
}
export default Account;

const styles = style({
  avatar_cont: {
    marginVertical: 20,
    alignItems: 'center'
  },
  name: {
    margin: 10,
    alignSelf: 'center',
    fontSize: theme.font_xl,
    color: theme.gray_color
  },
  item_list: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 10,
    margin: 0
  },
  item_text: {
    color: theme.primary_color
  },
  center: {
    alignSelf: 'center',
    marginVertical: 10
  },
  section_devider: {
    backgroundColor: theme.gray_color_lighten(0.05),
    height: 50
  }
});



// WEBPACK FOOTER //
// ./src/components/middle/settings/account.js